import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AddWaterBodiesComponent } from './add-water-bodies.component';
import { PendingChangesGuard } from '../../../../../core/services/pending-changes-guard';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'manage/admin/water-bodies/add-new',
        component: AddWaterBodiesComponent,
        canDeactivate: [PendingChangesGuard],
      },
      {
        path: 'manage/admin/water-bodies/edit/:waterBodyId',
        component: AddWaterBodiesComponent,
        data: {
          isEdit: true,
        },
      },
    ]),
  ],
  exports: [RouterModule],
})
export class AddWaterBodiesRoutingModule {}
